import { c as compute_rest_props, s as subscribe, i as is_promise, n as noop } from "../../../../../chunks/utils.js";
import { c as create_ssr_component, s as spread, b as escape_object, a as escape_attribute_value, i as each, d as add_attribute, e as escape, v as validate_component, g as getContext } from "../../../../../chunks/ssr.js";
import { A as Accordion, a as AccordionItem } from "../../../../../chunks/AccordionItem.js";
import { B as Button } from "../../../../../chunks/Button.js";
import { L as Label } from "../../../../../chunks/Label.js";
import { I as Input } from "../../../../../chunks/Input.js";
import { B as Badge } from "../../../../../chunks/Badge.js";
import { C as CloseButton } from "../../../../../chunks/CloseButton.js";
import { twMerge } from "tailwind-merge";
import { T as Tabs, a as TabItem } from "../../../../../chunks/Tabs.js";
import { s as sideMenuItems } from "../../../../../chunks/sideMenuItems.js";
import { T as Typeahead } from "../../../../../chunks/Typeahead.js";
import { g as get, p as post } from "../../../../../chunks/api.js";
import { i as invalidateAll } from "../../../../../chunks/client.js";
import { a as allUnits } from "../../../../../chunks/unit.js";
const multiSelectClass = "relative border border-gray-300 flex items-center rounded-lg gap-2 dark:border-gray-600 focus-within:ring-1 focus-within:border-primary-500 ring-primary-500 dark:focus-within:border-primary-500 dark:ring-primary-500";
const MultiSelect = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["items", "value", "size", "dropdownClass"]);
  let { items = [] } = $$props;
  let { value = [] } = $$props;
  let { size = "md" } = $$props;
  let { dropdownClass = "" } = $$props;
  let selectItems = items.filter((x) => value.includes(x.value));
  const sizes = {
    sm: "px-2 py-1 min-h-[2.4rem]",
    md: "px-3 py-1 min-h-[2.7rem]",
    lg: "px-4 py-2 min-h-[3.2rem]"
  };
  const clearThisOption = (select) => {
    if (value.includes(select.value)) {
      value = value.filter((o) => o !== select.value);
    }
  };
  if ($$props.items === void 0 && $$bindings.items && items !== void 0) $$bindings.items(items);
  if ($$props.value === void 0 && $$bindings.value && value !== void 0) $$bindings.value(value);
  if ($$props.size === void 0 && $$bindings.size && size !== void 0) $$bindings.size(size);
  if ($$props.dropdownClass === void 0 && $$bindings.dropdownClass && dropdownClass !== void 0) $$bindings.dropdownClass(dropdownClass);
  twMerge("absolute z-50 p-3 flex flex-col gap-1 max-h-64 bg-white border border-gray-300 dark:bg-gray-700 dark:border-gray-600 start-0 top-[calc(100%+1rem)] rounded-lg cursor-pointer overflow-y-scroll w-full", dropdownClass);
  return ` <select${spread(
    [
      escape_object($$restProps),
      { value: escape_attribute_value(value) },
      { hidden: true },
      { multiple: true }
    ],
    {}
  )}>${each(items, ({ value: value2, name }) => {
    return `<option${add_attribute("value", value2, 0)}>${escape(name)}</option>`;
  })}</select>  <div tabindex="-1" role="listbox"${add_attribute("class", twMerge(multiSelectClass, sizes[size], $$props.class), 0)}><span class="flex gap-2 flex-wrap">${selectItems.length ? `${each(selectItems, (item) => {
    return `${slots.default ? slots.default({ item, clear: () => clearThisOption(item) }) : ` ${validate_component(Badge, "Badge").$$render(
      $$result,
      {
        color: "dark",
        large: size === "lg",
        dismissable: true,
        params: { duration: 100 }
      },
      {},
      {
        default: () => {
          return `${escape(item.name)} `;
        }
      }
    )} `}`;
  })}` : ``}</span> <div class="flex ms-auto gap-2 items-center">${selectItems.length ? `${validate_component(CloseButton, "CloseButton").$$render(
    $$result,
    {
      size,
      color: "none",
      class: "p-0 focus:ring-gray-400"
    },
    {},
    {}
  )}` : ``} <div class="w-[1px] bg-gray-300 dark:bg-gray-600"></div> <svg class="cursor-pointer h-3 w-3 ms-1 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"${add_attribute("d", "m9 1-4 4-4-4", 0)}></path></svg></div> ${``}</div> `;
});
const TrashBinOutline = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["size", "role", "color", "withEvents", "title", "strokeWidth", "desc", "ariaLabel"]);
  const ctx = getContext("iconCtx") ?? {};
  const sizes = {
    xs: "w-3 h-3",
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
    xl: "w-8 h-8"
  };
  let { size = ctx.size || "md" } = $$props;
  let { role = ctx.role || "img" } = $$props;
  let { color = ctx.color || "currentColor" } = $$props;
  let { withEvents = ctx.withEvents || false } = $$props;
  let { title = {} } = $$props;
  let { strokeWidth = ctx.strokeWidth || "2" } = $$props;
  let { desc = {} } = $$props;
  let ariaDescribedby = `${title.id || ""} ${desc.id || ""}`;
  let hasDescription = false;
  let { ariaLabel = "trash bin outline" } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0) $$bindings.size(size);
  if ($$props.role === void 0 && $$bindings.role && role !== void 0) $$bindings.role(role);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0) $$bindings.color(color);
  if ($$props.withEvents === void 0 && $$bindings.withEvents && withEvents !== void 0) $$bindings.withEvents(withEvents);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0) $$bindings.title(title);
  if ($$props.strokeWidth === void 0 && $$bindings.strokeWidth && strokeWidth !== void 0) $$bindings.strokeWidth(strokeWidth);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0) $$bindings.desc(desc);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0) $$bindings.ariaLabel(ariaLabel);
  {
    if (title.id || desc.id) {
      hasDescription = true;
    } else {
      hasDescription = false;
    }
  }
  return `${withEvents ? `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: "none" },
      { color: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"${add_attribute("stroke-width", strokeWidth, 0)} d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"></path></svg>` : `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: "none" },
      { color: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"${add_attribute("stroke-width", strokeWidth, 0)} d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"></path></svg>`} `;
});
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $allUnits, $$unsubscribe_allUnits;
  $$unsubscribe_allUnits = subscribe(allUnits, (value) => $allUnits = value);
  let { data = [] } = $$props;
  let selected = [];
  const addUserToRole = async (item) => {
    if (!item) {
      return;
    }
    await post(`/user/role/${item.roleId}/${item.userId}`);
    await invalidateAll();
  };
  if ($$props.data === void 0 && $$bindings.data && data !== void 0) $$bindings.data(data);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${validate_component(Tabs, "Tabs").$$render($$result, {}, {}, {
      default: () => {
        return `${validate_component(TabItem, "TabItem").$$render($$result, { title: "Roles", open: true }, {}, {
          default: () => {
            return `${validate_component(Accordion, "Accordion").$$render($$result, {}, {}, {
              default: () => {
                return `${data.roles ? `${each(data.roles, (item) => {
                  return `${validate_component(AccordionItem, "AccordionItem").$$render($$result, {}, {}, {
                    header: () => {
                      return `<span slot="header">${escape(item.name)}</span>`;
                    },
                    default: () => {
                      let menu = JSON.parse(item.menuJson);
                      return `<div class="grid gap-3 grid-cols-3"><div><h3 class="text-lg" data-svelte-h="svelte-1d6r9fp">Accessible menu</h3> <ul class="list-disc ml-3">${each(menu, (item2) => {
                        return `<li>${escape(sideMenuItems.find((x) => x.href === item2)?.label)}</li>`;
                      })} </ul></div> <div>${validate_component(Typeahead, "Typeahead").$$render(
                        $$result,
                        {
                          data: data.associates,
                          extract: (ev) => addUserToRole({ ...ev, roleId: item.id })
                        },
                        {},
                        {
                          default: ({ item: item2 }) => {
                            return `${escape(item2.name)} (${escape(item2.position)} | ${escape(item2.email)})
                                `;
                          }
                        }
                      )} ${function(__value) {
                        if (is_promise(__value)) {
                          __value.then(null, noop);
                          return ``;
                        }
                        return function(userRole) {
                          return ` ${each(userRole, (role) => {
                            return `<div class="flex gap-3 justify-between my-2 border rounded p-2 items-center"><p>${escape(data.associates.find((x) => x.userId === role.userId)?.name)} <span class="text-sm leading-3">${escape(data.associates.find((x) => x.userId === role.userId)?.email)}</span></p> ${validate_component(Button, "Button").$$render($$result, { color: "red", pill: true, class: "!p-2" }, {}, {
                              default: () => {
                                return `${validate_component(TrashBinOutline, "TrashBinOutline").$$render($$result, {}, {}, {})} `;
                              }
                            })} </div>`;
                          })} `;
                        }(__value);
                      }(get("/user/role/" + item.id))} </div></div> `;
                    }
                  })}`;
                })}` : ``} ${validate_component(AccordionItem, "AccordionItem").$$render($$result, {}, {}, {
                  header: () => {
                    return `<span slot="header" data-svelte-h="svelte-1w7ha1n">Neue Rolle</span>`;
                  },
                  default: () => {
                    return `<form name="role-form" action="?/create_role" method="post">${validate_component(Label, "Label").$$render($$result, { class: "space-y-2" }, {}, {
                      default: () => {
                        return `<span data-svelte-h="svelte-15ueaex">Name</span> ${validate_component(Input, "Input").$$render($$result, { type: "text", name: "name" }, {}, {})}`;
                      }
                    })} <div class="mt-3">${validate_component(MultiSelect, "MultiSelect").$$render(
                      $$result,
                      {
                        dropdownClass: "bg-white",
                        items: sideMenuItems.map((x) => ({ value: x.href, name: x.label })),
                        value: selected
                      },
                      {
                        value: ($$value) => {
                          selected = $$value;
                          $$settled = false;
                        }
                      },
                      {}
                    )} <input type="hidden" name="menuJson"${add_attribute("value", selected, 0)}></div> <div class="mt-3">${validate_component(Button, "Button").$$render($$result, { type: "submit" }, {}, {
                      default: () => {
                        return `Anlegen`;
                      }
                    })}</div></form>`;
                  }
                })}`;
              }
            })}`;
          }
        })} ${validate_component(TabItem, "TabItem").$$render($$result, { title: "Unit" }, {}, {
          default: () => {
            return `${validate_component(Accordion, "Accordion").$$render($$result, {}, {}, {
              default: () => {
                return `${each($allUnits, (unit) => {
                  return `${validate_component(AccordionItem, "AccordionItem").$$render($$result, {}, {}, {
                    header: () => {
                      return `<span slot="header">${escape(unit.name)}</span>`;
                    }
                  })}`;
                })}`;
              }
            })}`;
          }
        })}`;
      }
    })}`;
  } while (!$$settled);
  $$unsubscribe_allUnits();
  return $$rendered;
});
export {
  Page as default
};
//# sourceMappingURL=_page.svelte.js.map
